import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import ReviewPage from "./ReviewPage";

function CorporateServices() {
  return (
    <>
      <Header />
      <section id="corporate-wellness-services" className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              CORPORATE WELLNESS
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get Your Employees Back to Optimal Health with Rapid Lab
                  Diagnostics' Corporate Wellness Services
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  At Rapid Lab Diagnostics, we understand the importance of
                  employee health and well-being in driving productivity and
                  success. Our Corporate Wellness services are designed to help
                  businesses promote a healthy work environment and support the
                  overall wellness of their employees. We offer comprehensive
                  health screenings, educational workshops, and personalized
                  wellness plans to help your employees maintain a healthy
                  lifestyle and reduce healthcare costs. Our team of experienced
                  healthcare professionals is dedicated to providing
                  high-quality care and support to ensure that your employees
                  stay healthy and productive. Contact us today to learn more
                  about our Corporate Wellness services and how we can help your
                  business thrive.
                </p>

                <p className="text-primary-emphasis">
                  {" "}
                  if you are interested in learning more about our Corporate
                  Wellness services or would like to schedule a consultation,
                  please contact us today. Our team is here to provide you with
                  the information and support you need to create a healthier and
                  more productive workplace for your employees.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/employee.png"
                  alt="echo"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="https://rgshealthcare.com/wp-content/uploads/2024/05/1200px_rgsHealthCare_AdobeStock_405836547-768x512.jpg"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/corporate.jpeg"
                    alt="ecg"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/heart.jpg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      Our Corporate Wellness services are designed to be
                      flexible and customizable to meet the unique needs of your
                      business and employees. We start by conducting a thorough
                      assessment of your workplace and employee health needs to
                      develop a tailored wellness program. This may include
                      health screenings, educational workshops, fitness
                      challenges, and personalized wellness plans. Our team will
                      work closely with you to implement the program and provide
                      ongoing support to ensure its success. We also offer
                      regular progress reports and evaluations to track the
                      effectiveness of the program and make any necessary
                      adjustments. With our Corporate Wellness services, you can
                      create a healthier and more productive work environment
                      for your employees while also reducing healthcare costs
                      for your business.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn btn-outline-primary text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for Corporate wellness
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className=" px-3 row align-items-center text-primary-emphasis fw-semibold  fs-4">
                  Why You Might Need Corporate Service
                </p>
                <p className="text-primary-emphasis">
                  Corporate health programs are essential because they directly
                  support the well-being, productivity, and long-term
                  sustainability of both employees and organizations. In today’s
                  fast-paced work environments, individuals often face high
                  levels of stress, long working hours, and sedentary
                  lifestyles, all of which can negatively impact physical and
                  mental health. Without proper support, these issues can lead
                  to burnout, chronic illness, absenteeism, and reduced
                  performance.
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "} Enhanced employee health and well-being through
                        access to screenings, fitness programs, and wellness
                        resources that promote healthy lifestyles and prevent
                        chronic diseases.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Boosted productivity and engagement by supporting
                        employee health, well-being, and job satisfaction,
                        reducing absenteeism and enhancing performance.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Boost employee well-being with easy access to health
                        screenings, fitness initiatives, and lifestyle
                        resources.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Corporate wellness programs that prioritize employee
                        health and well-being can strengthen company culture and
                        improve employee retention by showing that the
                        organization values and supports its staff.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you are seeking a corporate wellness services, Rapid Lab
                  Diagnostics is here to provide you with expert care, advanced
                  technology, and a compassionate approach to meet your
                  healthcare needs. Contact us today to schedule your
                  appointment and experience the difference in quality and care
                  that we offer.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/vitality.jpg"
                  alt="exercise"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}
            <ReviewPage />
            <div className="container text-center py-2 bg-muted  ">
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/medical-office-scene-doctor-patient-evaluating-cardiology-test-results.jpg"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose Rapid Lab Diagnostics for Your Corporate wellness
                    needs
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    At Rapid Lab Diagnostics, we are committed to providing
                    exceptional corporate wellness services with a focus on
                    patient care, accuracy, and comfort. Our state-of-the-art
                    facilities are equipped with the latest technology to ensure
                    precise diagnostics, while our experienced team of
                    healthcare professionals is dedicated to delivering
                    compassionate care tailored to the corporate needs. We
                    understand that undergoing medical tests can be stressful,
                    which is why we strive to create a welcoming and supportive
                    environment for all our patients. From the moment you walk
                    through our doors, you can expect personalized attention and
                    expert guidance throughout your ECG experience.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  Corporate Wellness Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What is corporate wellness, and why does it matter?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Corporate wellness is a set of programs and initiatives
                      aimed at improving employees’ physical, mental, and
                      emotional well-being. Studies show that healthy employees
                      are 25% more productive and take 28% fewer sick days,
                      which benefits both the employee and the company.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      What kinds of tests are included?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <ul className="text-start">
                        <li>
                          Blood tests: cholesterol, blood sugar, complete blood
                          count. Kidney & liver function tests.
                        </li>
                        <li>Vitamin & mineral levels: Vitamin D, B12, iron.</li>{" "}
                        <li>Thyroid & hormone screenings.</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Are the tests safe and confidential?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Yes. All procedures follow standard medical safety
                      protocols, and your results are strictly confidential,
                      shared only with you (and your doctor if needed).
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default CorporateServices;
